import { onReady } from './utils/on-ready';
import { bindComponentsToClass } from './utils/bind-components-to-class';

declare var window: any;

import '@material/web/dialog/dialog.js';
import '@material/web/switch/switch.js';
import '@material/web/textfield/outlined-text-field.js';
import '@material/web/textfield/filled-text-field.js';
import '@material/web/select/outlined-select.js';
import '@material/web/select/select-option.js';
import '@material/web/select/filled-select.js';
import '@material/web/checkbox/checkbox.js';
import '@material/web/radio/radio.js';

// Legacy Scripts
import './tooltip.js';
import './confetti.js';
import './form-input-handling.js';
import './knockout-validation.min.js';
import './MVC_Widget_Helpers.js';
import './array.prototype.includes.js';
import './agent-search-result-toggle.js';
import './carousel.js';

import Inputmask from 'inputmask/dist/inputmask';
window.Inputmask = Inputmask;

import { DatePickerController } from './date-picker';
window.datePicker = new DatePickerController();

// Common Components
import { PopupManager } from './popup';
import { MultilineQuote } from './multiline-quote';
import { LocalAgentFinder } from './local-agent-finder';
import { ContactAgencyPrincipal } from './contact-agency-principal';
import { MyAgentOverlay } from './my-agent-overlay';
import { AgencyPrincipalNavigation } from './agency-principal-navigation';
import { ApProfileCard } from './ap-profile-card';

window.apProfileCard = new ApProfileCard();

// LAZY-Load Page Specific Components
interface LazyComponentConfig {
    selector: string;
    loader: () => Promise<any>;
    init: (module: any, element: Element) => void;
}

const lazyComponentMap: LazyComponentConfig[] = [
    {
        selector: '#claims-satisfaction-survey',
        loader: () => import('./claims-satisfaction-survey'),
        init: (mod, el) => { window.claimsSurvey = new mod.ClaimsSatisfaction(el); }
    },
    {
        selector: '#financial-institution-inquiry',
        loader: () => import('./financial-institution-inquiry'),
        init: (mod, el) => { window.financialSurvey = new mod.FinancialInstitutionInquiry(el); }
    },
    {
        selector: '#reach-an-agent',
        loader: () => import('./reach-an-agent'),
        init: (mod, el) => { window.reachAgent = new mod.ReachAgent(el); }
    },
    {
        selector: '#drivetrend',
        loader: () => import('./drivetrend'),
        init: (mod, el) => { window.drivetrend = new mod.DriveTrend(el); }
    },
    {
        selector: '#life-calculator',
        loader: () => import('./life-calculator'),
        init: (mod, _el) => { window.lifeCalculator = new mod.LifeCalculator(); }
    },
    {
        selector: '#find-agent-office-map',
        loader: () => import('./find-agent-office-map'),
        init: (mod, _el) => { window.findAgentOfficeMap = new mod.FindAgentOfficeMap(); }
    },
    {
        selector: '#county-reachout-office-map',
        loader: () => import('./county-reachout-office-map'),
        init: (mod, _el) => { window.countyReacoutOfficeMap = new mod.CountyReacoutOfficeMap(); }
    },
    {
        selector: '.blog-carousel',
        loader: () => import('./blog-carousel'),
        init: (mod, _el) => { window.blogCarousel = new mod.BlogCarousel(); }
    },
    {
        selector: '.ad-feature-carousel',
        loader: () => import('./ad-feature-carousel'),
        init: (mod, _el) => { window.adFeatureCarousel = new mod.AdFeatureCarousel(); }
    },
    {
        selector: '.renters-quiz',
        loader: () => import('./renters-quiz'),
        init: (mod, _el) => { window.rentersQuiz = new mod.RentersQuiz(); }
    },
    {
        selector: '.homeowners-quiz',
        loader: () => import('./homeowners-quiz'),
        init: (mod, _el) => { window.homeownersQuiz = new mod.HomeownersQuiz(); }
    },
    {
        selector: '.randomize-images',
        loader: () => import('./randomize-images'),
        init: (mod, _el) => { window.randomizeImages = new mod.RandomizeImages(); }
    },
    {
        selector: '.linear-progress-indicator',
        loader: () => import('./linear-progress-indicator'),
        init: (mod, _el) => { window.linearProgressIndicator = new mod.LinearProgressIndicator(); }
    },
    {
        selector: '#career-interest-form',
        loader: () => import('./career-interest-form'),
        init: (mod, el) => { window.careerInterestForm = new mod.CareerInterestForm(el); }
    },
];

// Initialize everything on DOM Ready
onReady(() => {
    window.popupManager = new PopupManager();
    window.mlq = new MultilineQuote();

    window.localAgentFinders = bindComponentsToClass(
        LocalAgentFinder.cssClass,
        el => new LocalAgentFinder(el as HTMLButtonElement)
    );
    window.apContacts = bindComponentsToClass(
        ContactAgencyPrincipal.cssClass,
        el => new ContactAgencyPrincipal(el as HTMLFormElement)
    );
    window.agentOverlays = bindComponentsToClass(
        MyAgentOverlay.cssClass,
        el => new MyAgentOverlay(el as HTMLDivElement)
    );
    window.apNav = bindComponentsToClass(
        AgencyPrincipalNavigation.cssClass,
        el => new AgencyPrincipalNavigation(el as HTMLDivElement)
    );


    document.querySelectorAll('md-outlined-select[data-bind]').forEach(function (select) {
        select.addEventListener('change', function () {
            var val = (select as any).value;
            var koCtx = (window as any).ko?.contextFor?.(select);
            if (koCtx) {
                var bindAttr = select.getAttribute('data-bind') || '';
                var match = bindAttr.match(/value\s*:\s*(\w+)/);
                if (match) {
                    var obsName = match[1];
                    var vm = koCtx.$data;
                    if (vm && typeof vm[obsName] === 'function') {
                        vm[obsName](val);
                    }
                }
            }
        });
    });

    lazyComponentMap.forEach(config => {
        const element = document.querySelector(config.selector);
        if (element) {
            config.loader()
                .then(mod => config.init(mod, element))
                .catch(err => console.error(`Failed to load component for ${config.selector}:`, err));
        }
    });
});
